import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import logo from "../../asstes/images/logo.png";
import mobileLogo from "../../asstes/images/mobileLogo.png";
import mobileLogo2 from "../../asstes/images/Frame.png";
import ham from "../../asstes/images/hamberger.png";
import user from "../../asstes/images/user.png" 
import {MdOutlineClose} from "react-icons/md"
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../redux/store/auth/auth-slice';

const HomeNav = ({scrollSection, projectRef, aboutRef, reviewsRef}) => {


  const {userprofiledata} = useSelector((state)=>state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showNav,setShowNav] = useState(false)

  console.log(userprofiledata)

//   const setProfileData = (data)=>{
//     dispatch(authActions.adduserprofiledata(data))
//     navigate("/profile")
//     setShowNav(false)
//   }

  const Logiut = ()=>{
    navigate("/")
    setShowNav(false)
  }


  return (
    <div className=' shadow-lg bg-white lg:h-[100px] h-[66px] fixed w-[100%] z-20 lg:flex hidden items-center'>
        <div className="container">
           <div className='flex items-center justify-between'>
              <div className='logo -mt-2'>
                  <Link className=" hidden lg:flex" to={"/"}><img src={logo}  alt=""/></Link>
                  <Link className=" lg:hidden" to={"/"}><img src={mobileLogo}  alt=""/></Link>
              </div>
                <ul className='lg:flex items-center gap-[70px] p-0 hidden'>
                  <li onClick={()=>scrollSection(projectRef)} className='text-[20px] cursor-pointer font-normal'>Cómo funciona</li>
                  <li onClick={()=>scrollSection(aboutRef)} className='text-[20px] cursor-pointer font-normal'>Precios</li>
                  <li onClick={()=>scrollSection(reviewsRef)} className='text-[20px] cursor-pointer font-normal'>Dudas</li>
                  <li className='text-[20px] font-[700] text-[#4285F4]'>
                    <Link to={"/login"}>Regístrate | Inicia sesión</Link>
                  </li>
                </ul>


          </div> 
        </div>
    </div>
  )
}

export default HomeNav